























































import Vue from "vue";
import store, { NoticeStore } from "../services/NoticeStore";
import Page from "../../../components/Page.vue";
import NoticeDisplay from "../models/NoticeDisplay";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import dayjs from "dayjs";
import { ApiSearchColumn, ColumnType } from "@/components/apiSearch/models/ApiSearch";
import { t } from "@/plugins/i18n";

interface Data {
  store: NoticeStore;
  loading: boolean;
}

export default Vue.extend<Data, {}, {}, {}>({
  components: {
    Page,
    ApiSearchPage,
  },

  data(): Data {
    return {
      store,
      loading: false,
    };
  },

  computed: {
    columns: (): ApiSearchColumn[] => [
      { field: "entityId", title: t("Szamlaszam"), cell: "entityIdTemplate" },
      { field: "partner", title: t("Partner") },
      { field: "depot", title: t("Telephely") },
      { field: "type", title: t("Tipus") },
      { field: "status", title: t("Statusz") },
      { field: "genoType", title: t("Notice_GENOTipus") },
      {
        field: "entityCurrNetto",
        title: t("Netto"),
        //cell: "entityCurrNettoTemplate",
        headerClass: "align__right",
        fieldClass: "align__right",
        type: ColumnType.Money
      },
      {
        field: "entityCurrVat",
        title: t("AFA"),
        //cell: "entityCurrVatTemplate",
        headerClass: "align__right",
        fieldClass: "align__right",
        type: ColumnType.Money
      },
      {
        field: "entityCurrTotal",
        title: t("Total"),
        //cell: "entityCurrTotalTemplate",
        headerClass: "align__right",
        fieldClass: "align__right",
        type: ColumnType.Money
      },
      { field: "entityInvCurrency", title: t("Penznem"), cell: "entityInvCurrencyTemplate" },
      {
        field: "invDate",
        title: t("Notice_ErtesitoDatuma"),
        cell: "invDateTemplate",
        headerClass: "align__center",
        fieldClass: "align__center",
      },
      {
        field: "paymentTerm",
        title: t("FizetesiHatarido"),
        cell: "paymentTermTemplate",
        headerClass: "align__center",
        fieldClass: "align__center",
      },

      { cell: "commandTemplate", filterable: false },
    ],
  },

  methods: {
    newClick() {
      this.$router.push(`/notice/create`);
    },

    modify(item: NoticeDisplay) {
      this.$router.push(`/noto/${item.entity.id}`);
    },

    convertToDate(dateString: string) {
      if (dayjs(dateString).isValid()) {
        return dayjs(dateString).format("YYYY-MM-DD");
      }
      return "-";
    },
  },
});
